"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatFormCoinDecimalByBlockchain = exports.isEthlikeBlockchain = exports.networkToBlockchain = exports.Blockchain = exports.NetworkChainIdMap = exports.isSupportedNetwork = exports.Network = void 0;
var Network;
(function (Network) {
    Network["ETHEREUM"] = "ethereum";
    /** @deprecated NETWORK */
    Network["ROPSTEN"] = "ropsten";
    Network["GOERLI"] = "goerli";
    Network["POLYGON"] = "polygon";
    Network["MUMBAI"] = "mumbai";
    Network["BNB_SMART_CHAIN"] = "bnb_smart_chain";
    Network["BNB_SMART_CHAIN_TESTNET"] = "bnb_smart_chain_testnet";
    Network["KLAYTN"] = "klaytn";
    Network["BAOBAB"] = "baobab";
    Network["SOLANA"] = "solana";
    Network["SOLANA_DEVNET"] = "solana_devnet";
    Network["NEAR"] = "near";
    Network["NEAR_TESTNET"] = "near_testnet";
    Network["BORA"] = "bora";
    Network["BORA_TESTNET"] = "bora_testnet";
    /** @deprecated use ETHEREUM */
    Network["ETH_MAINNET"] = "ethereum";
    /** @deprecated use ROPSTEN */
    Network["ETH_TESTNET"] = "ropsten";
    /** @deprecated use POLYGON */
    Network["MATIC_MAINNET"] = "polygon";
    /** @deprecated use MUMBAI */
    Network["MATIC_TESTNET"] = "mumbai";
    /** @deprecated use BNB_SMART_CHAIN */
    Network["BINANCE_COIN_MAINNET"] = "bnb_smart_chain";
    /** @deprecated use BNB_SMART_CHAIN_TESTNET */
    Network["BINANCE_COIN_TESTNET"] = "bnb_smart_chain_testnet";
    /** @deprecated use KLAYTN */
    Network["KLAYTN_MAINNET"] = "klaytn";
    /** @deprecated use BAOBAB */
    Network["KLAYTN_TESTNET"] = "baobab";
    Network["APTOS"] = "aptoslab";
    Network["APTOS_TESTNET"] = "aptoslab_testnet";
    Network["MEVERSE"] = "meverse";
    Network["MEVERSE_TESTNET"] = "meverse_testnet";
})(Network = exports.Network || (exports.Network = {}));
const isSupportedNetwork = (network) => {
    switch (network) {
        case Network.ETHEREUM:
        case Network.GOERLI:
        case Network.POLYGON:
        case Network.MUMBAI:
        case Network.BNB_SMART_CHAIN:
        case Network.BNB_SMART_CHAIN_TESTNET:
        case Network.KLAYTN:
        case Network.BAOBAB:
        case Network.SOLANA:
        case Network.SOLANA_DEVNET:
        case Network.NEAR:
        case Network.NEAR_TESTNET:
        case Network.BORA:
        case Network.BORA_TESTNET:
        case Network.APTOS:
        case Network.APTOS_TESTNET:
        case Network.MEVERSE:
        case Network.MEVERSE_TESTNET:
            return true;
        default:
            return false;
    }
};
exports.isSupportedNetwork = isSupportedNetwork;
exports.NetworkChainIdMap = {
    [Network.ETHEREUM]: 1,
    [Network.ROPSTEN]: 3,
    [Network.GOERLI]: 5,
    [Network.POLYGON]: 137,
    [Network.MUMBAI]: 80001,
    [Network.BNB_SMART_CHAIN]: 56,
    [Network.BNB_SMART_CHAIN_TESTNET]: 97,
    [Network.KLAYTN]: 8217,
    [Network.BAOBAB]: 1001,
    [Network.SOLANA]: 0,
    [Network.SOLANA_DEVNET]: 0,
    [Network.NEAR]: 0,
    [Network.NEAR_TESTNET]: 0,
    [Network.BORA]: 77001,
    [Network.BORA_TESTNET]: 99001,
    [Network.APTOS]: 1,
    [Network.APTOS_TESTNET]: 2,
    [Network.MEVERSE]: 7518,
    [Network.MEVERSE_TESTNET]: 4759,
    1: Network.ETHEREUM,
    3: Network.ROPSTEN,
    5: Network.GOERLI,
    137: Network.POLYGON,
    80001: Network.MUMBAI,
    56: Network.BNB_SMART_CHAIN,
    97: Network.BNB_SMART_CHAIN_TESTNET,
    8217: Network.KLAYTN,
    1001: Network.BAOBAB,
    77001: Network.BORA,
    99001: Network.BORA_TESTNET,
    7518: Network.MEVERSE,
    4759: Network.MEVERSE_TESTNET,
};
var Blockchain;
(function (Blockchain) {
    Blockchain["ETHEREUM"] = "ETHEREUM";
    Blockchain["POLYGON"] = "POLYGON";
    Blockchain["BNB_SMART_CHAIN"] = "BNB_SMART_CHAIN";
    Blockchain["KLAYTN"] = "KLAYTN";
    Blockchain["SOLANA"] = "SOLANA";
    Blockchain["NEAR"] = "NEAR";
    Blockchain["BORA"] = "BORA";
    Blockchain["APTOS"] = "APTOS";
    Blockchain["MEVERSE"] = "MEVERSE";
})(Blockchain = exports.Blockchain || (exports.Blockchain = {}));
const EthLikeBlockchains = [
    Blockchain.ETHEREUM,
    Blockchain.POLYGON,
    Blockchain.BNB_SMART_CHAIN,
    Blockchain.KLAYTN,
    Blockchain.BORA,
    Blockchain.MEVERSE,
];
function networkToBlockchain(network) {
    switch (network) {
        case Network.ETHEREUM:
        case Network.ROPSTEN:
        case Network.GOERLI:
            return Blockchain.ETHEREUM;
        case Network.POLYGON:
        case Network.MUMBAI:
            return Blockchain.POLYGON;
        case Network.BNB_SMART_CHAIN:
        case Network.BNB_SMART_CHAIN_TESTNET:
            return Blockchain.BNB_SMART_CHAIN;
        case Network.KLAYTN:
        case Network.BAOBAB:
            return Blockchain.KLAYTN;
        case Network.SOLANA:
        case Network.SOLANA_DEVNET:
            return Blockchain.SOLANA;
        case Network.BORA:
        case Network.BORA_TESTNET:
            return Blockchain.BORA;
        case Network.NEAR:
        case Network.NEAR_TESTNET:
            return Blockchain.NEAR;
        case Network.APTOS:
        case Network.APTOS_TESTNET:
            return Blockchain.APTOS;
        case Network.MEVERSE:
        case Network.MEVERSE_TESTNET:
            return Blockchain.MEVERSE;
    }
    throw new Error(`Unsupported network: ${network}`);
}
exports.networkToBlockchain = networkToBlockchain;
function isEthlikeBlockchain(blockchain) {
    return EthLikeBlockchains.indexOf(blockchain) !== -1;
}
exports.isEthlikeBlockchain = isEthlikeBlockchain;
const getPlatFormCoinDecimalByBlockchain = (blockchain) => {
    switch (blockchain) {
        case Blockchain.ETHEREUM:
        case Blockchain.POLYGON:
        case Blockchain.KLAYTN:
        case Blockchain.BNB_SMART_CHAIN:
        case Blockchain.BORA:
        case Blockchain.MEVERSE:
            return 18;
        case Blockchain.SOLANA:
            return 9;
        case Blockchain.NEAR:
            return 24;
        case Blockchain.APTOS:
            return 8;
        default:
            throw new Error('unsupported blockchain');
    }
};
exports.getPlatFormCoinDecimalByBlockchain = getPlatFormCoinDecimalByBlockchain;
//# sourceMappingURL=blockchain.js.map